import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import UpdatePrompt from './components/common/UpdatePrompt/UpdatePrompt';

// Pages
import Home from './components/pages/Home';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './components/pages/Dashboard/Dashboard';
import DeckManager from './components/pages/Dashboard/DeckManager';
import NewsList from './components/pages/Dashboard/NewsList';
import NewsPage from './components/pages/Dashboard/NewsPage';
import NewsDetail from './components/pages/Dashboard/NewsDetail';
import ArchivedNews from './components/pages/Dashboard/ArchivedNews';
import DeckDetail from './components/pages/Dashboard/DeckDetail';
import UsersPage from './components/pages/Dashboard/UsersPage';
import DevTool from './components/pages/Dashboard/DevTool';
import BugReports from './components/pages/Dashboard/BugReports';
import GoogleCallback from './components/pages/GoogleCallback';
import NotFound from './components/pages/NotFound/NotFound';

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

function App() {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <AuthProvider>
          {/* Watches the backend's build number on every route, public ones
              included, and prompts when this tab is running an old build */}
          <UpdatePrompt />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />

              {/* Google OAuth callback */}
              <Route path="auth/google/callback" element={<GoogleCallback />} />

              {/* Protected routes */}
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="decks/:id" element={<DeckDetail />} />
                <Route path="news" element={<NewsPage />} />
                <Route path="news/:id" element={<NewsDetail />} />
                <Route path="archived" element={<ArchivedNews />} />
                <Route path="create" element={<DeckManager layout="side-by-side" fullWidth />} />
                <Route
                  path="users"
                  element={
                    <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="bug-reports" element={<BugReports />} />
                <Route path="settings" element={<DevTool />} />
              </Route>

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
